import PdfDisplay from './PdfDisplay';

export default PdfDisplay;
